import React, { useState, useEffect, useRef, memo } from "react";

import "./sidebarPanel.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/scrollbar";

import { useSelector } from "react-redux";
import ActivityCategory from "./activityCategory";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import { selectCategory } from "../../../redux/slices/activityCategories";
import { useDispatch } from "react-redux";
import { toggleVideoVisible } from "../../../redux/slices/userActivity";

function SidebarPanel({ duonutId }) {
  const { categories } = useSelector((state) => state.activityCategories);
  const { height } = useWindowDimensions()

  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);
  const { isVideo } = useSelector((state) => state.userActivity);
  const dispatch = useDispatch()

  // console.log({isVideo});
  // console.log({categories});
  useEffect(() => {
    if (!categories) return
    if (categories.length === 0) return
    if (isVideo) {
      let temp = categories.map(cat => {
        if (cat.name === "Video Activity") {
          if (cat.isSelected) return
          dispatch(selectCategory({ id: cat.id }))
          dispatch(toggleVideoVisible({ videoVisible: false }))
        }
      })
    } else {
      // dispatch(selectCategory({ id: cat.id }))
      // dispatch(toggleVideoVisible({ videoVisible: false }))
    }
  }, [categories, isVideo])

  return (
    <div className="sidebar_panel">
      <div className="activity_categories">

        <div className="activity_category up_arrow" ref={navigationPrevRef}>
          <div className="activity_category__icon_container" style={{ width: "32px", height: "32px" }}>
            <svg style={{ width: "11px" }} transform="rotate(180)" width="30" height="30" viewBox="1 -1 26 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.7033 1.17167C25.46 1.92831 25.46 3.15507 24.7033 3.91171L14.37 14.245C13.6133 15.0017 12.3866 15.0017 11.6299 14.245L1.29661 3.91171C0.539966 3.15507 0.539966 1.92831 1.29661 1.17167C2.05325 0.415028 3.28 0.415028 4.03665 1.17167L13 10.135L21.9633 1.17167C22.7199 0.415027 23.9467 0.415027 24.7033 1.17167Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
        <div className="activity_category down_arrow" ref={navigationNextRef}
          style={{ position: 'absolute', bottom: '0', left: '50%', transform: 'translateX(-50%)' }} >
          <div className="activity_category__icon_container"
            style={{ width: "32px", height: "32px" }}>
            <svg style={{ width: "11px" }} width="10" height="10" viewBox="1 -2 26 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.7033 1.17167C25.46 1.92831 25.46 3.15507 24.7033 3.91171L14.37 14.245C13.6133 15.0017 12.3866 15.0017 11.6299 14.245L1.29661 3.91171C0.539966 3.15507 0.539966 1.92831 1.29661 1.17167C2.05325 0.415028 3.28 0.415028 4.03665 1.17167L13 10.135L21.9633 1.17167C22.7199 0.415027 23.9467 0.415027 24.7033 1.17167Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
        <Swiper
          className="activity_types__slider"
          slidesPerView={height < 700 ? 3 : height < 830 ? 4 : height < 960 ? 5 : 6}
          slidesPerGroup={2}
          direction={"vertical"}
          mousewheel={true}
          navigation={{
            prevEl: navigationPrevRef.current,
            nextEl: navigationNextRef.current,
          }}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = navigationPrevRef.current;
            swiper.params.navigation.nextEl = navigationNextRef.current;
          }}
          modules={[Mousewheel, Navigation]}
          style={{ height: height < 700 ? '360px' : height < 830 ? '480px' : height < 960 ? '600px' : '720px' }}
        // scrollbar={{
        //   // hide: true,
        //   // draggable: true,
        //   snapOnRelease: false,
        //   enabled: false
        // }}
        >
          {categories.length >= 1 && categories.map((category) => {
            return (
              <SwiperSlide key={category.id} style={{ height: '112px', marginLeft: '0', display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
                <ActivityCategory key={category.id} {...category} />;
              </SwiperSlide>
            )
          })}
        </Swiper>

      </div>
    </div>
  );
}

export default memo(SidebarPanel)
